<div class="pb-10 pb-lg-12" dir="rtl">
  <h2 class="fw-bolder text-dark">أدخل بياناتك :</h2>
</div>
<div [formGroup]="form" dir="rtl">
  <div class="fv-row mb-10">
    <label class="form-label required">الأسم الكامل</label><input name="customerName"
    placeholder="أدخل اسمك بالكامل"
      class="form-control form-control-lg form-control-solid" formControlName="customerName" />
    <div class="fv-plugins-message-container invalid-feedback" *ngIf="
        form.get('customerName')?.hasError('required') &&
        form.get('customerName')?.touched
      ">
      هذا الحقل مطلوب
    </div>
  </div>
  <div class="fv-row mb-10">
    <label class="d-flex align-items-center form-label"><span class="required">رقم الهاتف</span></label><input
    placeholder="أدخل رقم هاتفك"
      name="customerPhone" class="form-control form-control-lg form-control-solid" formControlName="customerPhone" />
    <div class="fv-plugins-message-container invalid-feedback" *ngIf="
        form.get('customerPhone')?.hasError('required') &&
        form.get('customerPhone')?.touched
      ">
      هذا الحقل مطلوب
    </div>
  </div>
  <div class="fv-row mb-0">
    <label class="fs-6 fw-bold form-label required">البريد الالكتروني </label><input name="customerEmail"
    placeholder="أدخل بريدك الإلكتروني"
      class="form-control form-control-lg form-control-solid" formControlName="customerEmail" />
    <div class="fv-plugins-message-container invalid-feedback" *ngIf="
        form.get('customerEmail')?.hasError('required') &&
        form.get('customerEmail')?.touched &&
        form.get('customerEmail')?.errors
      ">
      هذا الحقل أجباري
    </div>
    <div class="fv-plugins-message-container invalid-feedback" *ngIf="
        form.get('customerEmail')?.hasError('email') 
      ">
      تأكد من البريد المدخل
    </div>
  </div>
</div>
